import React, { Component, Fragment } from 'react';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Immutable from 'immutable';
import cx from 'classnames';
import { compose } from 'recompose';
import { getVersion } from 'settings';
import { signOutAction } from 'redux/reducers/app';

import { isElectron, removeLocalItem } from 'shared/util/utils';

import HeaderDetail from 'containers/App/Header/HeaderDetail';
import LinkWrapper from 'components/LinkWrapper/LinkWrapper';

// import headerlogoText from 'design/images/header/header-log.svg';
import headerlogoText from 'design/images/Logos/logo-white.png';
// import headerlogoLight from 'design/images/header/header-logo-white.svg';
import headerlogoLight from 'design/images/Logos/logo-white.png';
import headerIconApp from 'design/images/header/header-icon-app.svg';
import headerIconBrowser from 'design/images/header/header-icon-browser.svg';

import './Header.scss';

const mapStateToProps = (state) => {
	const user = state.app.get('user');
	return {
		user,
	};
};

const mapDispatchToProps = {
	signOutAction,
};

class Header extends Component {
	static propTypes = {
		user: PropTypes.instanceOf(Immutable.Iterable),
		signOutAction: PropTypes.func,
	};

	static defaultProps = {
		user: null,
	};

	isHeaderWhite = () => {
		const pathname = this.props.location.pathname;
		const user = this.props.user;

		if (pathname.startsWith('/registration')) return true;
		if (pathname.startsWith('/verify')) return true;
		if (!user) return true;
		return false;
	};

	signOut = () => {
		// console.log("signOut")
		const { signOutAction, history } = this.props;

		removeLocalItem('currentCourse');
		removeLocalItem('currentLesson');

		history.push(`/login`);

		signOutAction();
	};

	renderVersion = () => {
		return (
			<Fragment>
				<span>
					<img alt='device' className='env-icon' src={isElectron() ? headerIconApp : headerIconBrowser} />
				</span>
				<Typography className='version-text' id='version'>
					{getVersion()}
				</Typography>
			</Fragment>
		);
	};

	renderLogo = () => {
		return (
			<LinkWrapper isLink={true} linkTo='/'>
				<img
					alt='codingbar'
					id='Header-logo'
					className='Header-logo'
					style={{ maxWidth: '100px', height: 'auto' }}
					src={this.isHeaderWhite() ? headerlogoText : headerlogoLight}
				/>
			</LinkWrapper>
		);
	};

	renderHeaderItem = () => {
		const { user, togglePlayground, toggleZoom } = this.props;

		if (!user) return null;

		return (
			<span className='Header-link'>
				<HeaderDetail togglePlayground={togglePlayground} toggleZoom={toggleZoom} />
			</span>
		);
	};

	render() {
		const { user, headerDisabled } = this.props;

		const headerWrapperClassName = cx('Header', {
			'Header-white': this.isHeaderWhite(),
			'Header-light': !this.isHeaderWhite() && !user,
			'Header-dark': !this.isHeaderWhite() && user,
		});

		if (headerDisabled) return null;

		// render menu when user is authorized
		return (
			<header className={headerWrapperClassName}>
				{this.renderLogo()}
				{this.renderVersion()}
				{this.renderHeaderItem()}
			</header>
		);
	}
}

export default compose(withRouter, translate('translations'), connect(mapStateToProps, mapDispatchToProps))(Header);
